const config = {
  api: '',
  trackAnalytics: process.env.TRACKANALYTICS,
  loginMode: process.env.LOGINMODE
};
export default config;



// WEBPACK FOOTER //
// ./source/client/actions/config/index.js